import React, { useState } from 'react';

const TesourariaDashboard = () => {
  return (
    <div className="p-6 bg-zinc-950 text-zinc-50 min-h-screen rounded-lg border border-zinc-800">
      
      {/* Cabeçalho da Página */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-red-500 uppercase tracking-wider">Centro de Comando</h1>
          <p className="text-zinc-400 mt-1">Visão Geral Financeira do Clube</p>
        </div>
        
        {/* Aqui vai entrar o botão de Configurar Data Limite depois */}
        <button className="bg-zinc-800 hover:bg-zinc-700 text-sm px-4 py-2 rounded border border-zinc-700 transition-colors">
          ⚙️ Parâmetros do Mês
        </button>
      </div>

      {/* Grid Superior: Cards de Resumo */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-zinc-900 p-6 rounded-lg border border-zinc-800 shadow-md">
          <h3 className="text-zinc-400 text-sm font-medium uppercase tracking-wider">Saldo Consolidado Total</h3>
          <p className="text-3xl font-bold mt-2 text-emerald-500">R$ 0,00</p>
        </div>
        <div className="bg-zinc-900 p-6 rounded-lg border border-zinc-800 shadow-md">
          <h3 className="text-zinc-400 text-sm font-medium uppercase tracking-wider">Arrecadação do Mês</h3>
          <p className="text-3xl font-bold mt-2 text-zinc-50">R$ 0,00</p>
        </div>
        <div className="bg-zinc-900 p-6 rounded-lg border border-zinc-800 shadow-md">
          <h3 className="text-zinc-400 text-sm font-medium uppercase tracking-wider">Pendente / Atrasado</h3>
          <p className="text-3xl font-bold mt-2 text-red-500">R$ 0,00</p>
        </div>
      </div>

      {/* Espaço para os Gráficos Recharts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-zinc-900 p-6 rounded-lg border border-zinc-800 min-h-[300px] flex items-center justify-center">
          <p className="text-zinc-600 font-mono">[ Área Reservada: Gráfico de Receitas vs Despesas ]</p>
        </div>
        <div className="bg-zinc-900 p-6 rounded-lg border border-zinc-800 min-h-[300px] flex items-center justify-center">
          <p className="text-zinc-600 font-mono">[ Área Reservada: Gráfico de Adimplência Mensal ]</p>
        </div>
      </div>

    </div>
  );
};

export default TesourariaDashboard;
